import type { Pagination } from '../types';

const BASE = import.meta.env.VITE_API_BASE || '/api';

export class ApiError extends Error {
  status: number;
  /** Code applicatif renvoye par l'API (ex. STEP_UP_REQUIRED), absent la plupart du temps. */
  code?: string;
  constructor(message: string, status: number, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export interface ApiResult<T> {
  data: T;
  pagination?: Pagination;
}

export async function api<T>(path: string, init?: RequestInit): Promise<ApiResult<T>> {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
    ...init,
  });

  let body: {
    success?: boolean;
    data?: T;
    error?: string;
    code?: string;
    pagination?: Pagination;
  } = {};
  try {
    body = await res.json();
  } catch {
    // non-JSON response
  }

  if (!res.ok || body.success === false) {
    throw new ApiError(body.error || `Erreur ${res.status}`, res.status, body.code);
  }
  return { data: body.data as T, pagination: body.pagination };
}

export function apiBase(): string {
  return BASE;
}
